import { useGate, useStore } from 'effector-react'
import { useMemo } from 'react'
import { SimplifiedRegistration } from '~/features/SimplifiedRegistration'
import {
  useTitle,
  simplifiedRegistrationStepModel,
} from '~/features/SimplifiedRegistration'
import { PageContainer } from '~/shared/ui/PageContainer'

export const SimplifiedRegistrationPage = () => {
  useGate(simplifiedRegistrationStepModel.Gate)

  const { isConfirmCodeStep, isErrorStep } = useStore(
    simplifiedRegistrationStepModel.$currentStepFlags,
  )

  const title = useTitle()

  const pageContainerProps = useMemo(() => {
    return {
      ...(isConfirmCodeStep
        ? {
            contentFillColor: null,
            onBack: simplifiedRegistrationStepModel.goToFirstStep,
          }
        : {}),
      ...(isErrorStep
        ? { onBack: simplifiedRegistrationStepModel.goToFirstStep }
        : {}),
    }
  }, [isConfirmCodeStep, isErrorStep])

  return (
    <PageContainer
      title='Регистрация'
      backTitle={title}
      canBack
      {...pageContainerProps}
    >
      <SimplifiedRegistration />
    </PageContainer>
  )
}
